import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  notification,
  Upload,
  Row,
  Col,
  Select,
  Checkbox,
  Divider,
} from "antd";
import Joi from "joi";
// import Joi from "joi";
import { PlusOutlined } from "@ant-design/icons";
import slugify from "react-slugify";

import http from "../../../../helpers/http";
// import config from "../../config/config";
// import HtmlEditor from "../../components/HtmlEditor";
import axios from "axios";
import _ from "lodash";
import urldata from "../../../../urldata";
import helper from "../../../../helpers/helper";

const Create = ({ isVisible, handleClose, moduleName, brands }) => {
  const [form] = Form.useForm();
  const [loading, setloading] = useState(false);
  const [formError, setFormError] = useState({});

  const base_url = urldata + "admin/roles"; //without trailing slash
  const image_url = urldata + "uploads/role/"; //with trailing slash
  const sizeLimit = 1;

  const { TextArea } = Input;
  const { Option } = Select;
  const CheckboxGroup = Checkbox.Group;

  const permissions = [
    {
      label: "Homepage",
      value: "homepage",
    },
    {
      label: "About Us",
      value: "about_us",
    },
    {
      label: "Our Brands",
      value: "our_brands",
    },
    {
      label: "Media",
      value: "media",
    },
    {
      label: "Collaborate",
      value: "collaborate",
    },
    {
      label: "Career",
      value: "career",
    },
    {
      label: "Contact Us",
      value: "contact_us",
    },
    {
      label: "Footer",
      value: "footer",
    },
    {
      label: "Privacy Policy",
      value: "privacy_policy",
    },
    {
      label: "PDF Content",
      value: "pdf_content",
    },
    {
      label: "Our Catalogue",
      value: "our_catalogue",
    },
  ];
  const defaultCheckedList = ["Apple", "Orange"];
  //validation schema

  const schema = Joi.object({
    name: Joi.string().trim().required().label("Name"),
    permissions: Joi.array().min(1).required().label("Permissions")
  }).options({ allowUnknown: true });

  const validate = async (data) => {
    const { error } = schema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
      errors: {
        wrap: {
          label: "",
        },
      },
    });

    const errors = {};

    if (error) {
      error.details.map((field) => {
        errors[field.path[0]] = field.message;
        return true;
      });
    }

    // validating unique slug
    // if (data.slug) {
    //   const result = await helper.validateSlug(data.slug, "ProductCategory");

    //   if (result == false) {
    //     errors["slug"] = `This slug is already used.`;
    //   }
    // }

    return errors ? errors : null;
  };

  const handleSubmit = async (value) => {
    console.log(value);
    // return;
    let errors = await validate(value);
    setFormError(errors);

    if (Object.keys(errors).length) {
      return;
    }

    setloading(true);

    const { data } = await http.post(base_url, value);

    if (data) {
      notification["success"]({
        message: `${moduleName} Added Successfully`,
      });
      setloading(false);

      // form.resetFields();

      handleClose();
    }
  };

  return (
    <Modal
      title={`Add ${moduleName}`}
      visible={isVisible}
      onCancel={handleClose}
      okText="Create"
      cancelText="Cancel"
      confirmLoading={loading}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            handleSubmit(values);
          })
          .catch((info) => {});
      }}
      width={700}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={15}>
          <Col span={24}>
            <Form.Item
              required
              label="Name:"
              name="name"
              {...(formError.name && {
                help: formError.name,
                validateStatus: "error",
              })}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              required
              label="Permissions:"
              name="permissions"
              {...(formError.permissions && {
                help: formError.permissions,
                validateStatus: "error",
              })}
            >
              <CheckboxGroup
                style={{
                  width: "100%",
                }}
              >
                
                <Row gutter={[16,16]}>
                {
                  permissions.map(({label,value})=>{
                    return  <Col span={8}>
                    <Checkbox value={value}>{label}</Checkbox>
                  </Col>
                  })
                }
                  {/* <Col span={8}>
                    <Checkbox value="A">A</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="B">B</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="C">C</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="D">D</Checkbox>
                  </Col>
                  <Col span={8}>
                    <Checkbox value="E">E</Checkbox>
                  </Col> */}
                </Row>
              </CheckboxGroup>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default Create;
